import { gql } from "@apollo/client";

const PURCHASER_PORTAL_KEY_FIELDS = `
  id
  portalKeyName
  portalKey
  appPurchaserId
  purchaserKey
`;

export const GET_PURCHASER_PORTAL_KEYS = gql`
  query PurchaserPortalKeys($purchaserId: Int!) {
    purchaserPortalKeys(purchaserId: $purchaserId) {
      ${PURCHASER_PORTAL_KEY_FIELDS}
    }
  }
`;

export const CREATE_PURCHASER_PORTAL_KEY = gql`
  mutation CreatePurchaserPortalKey($params: CreatePurchaserPortalKeyInput!) {
    createPurchaserPortalKey(params: $params) {
      ${PURCHASER_PORTAL_KEY_FIELDS}
    }
  }
`;

export const UPDATE_PURCHASER_PORTAL_KEY = gql`
  mutation UpdatePurchaserPortalKey($params: UpdatePurchaserPortalKeyInput!) {
    updatePurchaserPortalKey(params: $params) {
      ${PURCHASER_PORTAL_KEY_FIELDS}
    }
  }
`;
